import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  mobile,
  SkeletonLine,
  useBreakpoint,
} from '~/techstyle-shared/react-components';
import FormattedMessage from '~/techstyle-shared/react-intl/src/FormattedMessage/FormattedMessage';

const StyledNumResultsText = styled.div`
  font-size: 14px;
  font-weight: 350;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gridV2NumResultsText};

  ${mobile`
    font-size: 12px;
  `}
`;

const NumResults = ({ totalNumResults, isLoading }) => {
  const { isMobile } = useBreakpoint();

  if (isLoading) {
    return <SkeletonLine width={isMobile ? 24 : 72} height={12} />;
  }

  if (!totalNumResults) {
    return null;
  }

  return (
    <StyledNumResultsText>
      {isMobile ? (
        `[${totalNumResults}]`
      ) : (
        <FormattedMessage
          id="grid_static.product_results"
          defaultMessage="{productCount} Results"
          values={{ productCount: totalNumResults }}
        />
      )}
    </StyledNumResultsText>
  );
};

NumResults.propTypes = {
  isLoading: PropTypes.bool,
  totalNumResults: PropTypes.number,
};

export default NumResults;
